
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPilotage as ObiPilotageElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pilotage.js';
 
 
 

 
 export const ObiPilotage = createComponent({
   react: React,
   tagName: 'obi-pilotage',
   elementClass: ObiPilotageElement,
   events: {
     
   }
  });
 
 